import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaPhoneAlt, FaHeadset } from 'react-icons/fa';

export default function ForgotPassword() {
    return (
        <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-blue-50">
            {/* Background Decorations */}
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-200 via-blue-100 to-white"></div>

            <div className="relative w-full max-w-md p-8 bg-white/60 backdrop-blur-2xl rounded-3xl shadow-xl border border-white/50 m-4">
                <Link to="/login" className="inline-flex items-center gap-2 text-sm font-bold text-gray-500 hover:text-gray-900 mb-8 transition-colors">
                    <FaArrowLeft /> Back to Login
                </Link>

                <div className="text-center mb-8">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <FaHeadset className="text-blue-600 text-2xl" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900">Forgot Password?</h2>
                    <p className="mt-2 text-sm text-gray-500 font-medium">
                        Please contact our support team to reset your password.
                    </p>
                </div>

                <div className="space-y-4">
                    <div className="bg-white/80 p-4 rounded-2xl border border-blue-100 shadow-sm flex items-center gap-4">
                        <div className="bg-blue-600 p-3 rounded-xl text-white">
                            <FaPhoneAlt />
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 font-bold uppercase">Main Hotline</p>
                            <p className="text-lg font-bold text-gray-900 tracking-wide">0772 700 701</p>
                        </div>
                    </div>

                    <div className="bg-white/80 p-4 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4">
                        <div className="bg-gray-800 p-3 rounded-xl text-white">
                            <FaHeadset />
                        </div>
                        <div>
                            <p className="text-xs text-gray-500 font-bold uppercase">Technical Support</p>
                            <p className="text-lg font-bold text-gray-900 tracking-wide">0117 109 690</p>
                        </div>
                    </div>
                </div>

                <div className="mt-8 text-center">
                    <p className="text-xs text-gray-400">
                        Available Mon - Sun: 8:00 AM - 8:00 PM
                    </p>
                </div>
            </div>
        </div>
    );
}
